import { snakeCase } from 'lodash';
import { Dispatch, SetStateAction } from 'react';
import { useLocalStorage } from './use-local-storage';

export enum AccountFeature {
  Timesheets = 'timesheets',
  Financials = 'financials',
  Invoices = 'invoices',
  SprintPlanning = 'sprintPlanning',
  AiFills = 'aiFills',
  AiCredits = 'aiCredits',
  Epics = 'epics',
  Backlogs = 'backlogs',
  Expenses = 'expenseManagement',
  Taxes = 'taxes',
  CreditNotes = 'creditNotes',
  DashboardV2 = 'dashboardV2',
  ForcePrivateAttachments = 'forcePrivateAttachments',
  TimesheetPolicies = 'timesheetPolicies',
  Scim = 'scim',
  RestrictUserGroups = 'restrictUserGroups',
  MultiLineBudgets = 'multiLineBudgets',
  EmailIntelligence = 'emailIntelligence',
  NewUI = 'newUI',
  DashboardRestrictedVisibility = 'dashboardRestrictedVisibility',
  MigrationAgent = 'migrationAgent',
  PolicyEvaluation = 'policyEvaluation',
  WorkforceAgent = 'workforceAgent',
  MultiLevelPivots = 'multiLevelPivots',
  CustomReportsBudgetSourceTabular = 'customReportsBudgetSourceTabular',
  CustomReportsBudgetSourcePivot = 'customReportsBudgetSourcePivot',
  OverallFinancialsOptimization = 'overallFinancialsOptimization',
  SlackPvtChannels = 'slackPvtChannels',
}

export const useAccountFeature = (
  feature: AccountFeature,
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  return useLocalStorage<boolean>(
    `__account_features.${snakeCase(feature)}`,
    false,
  );
};
